import { createSlice } from '@reduxjs/toolkit'
import { IInsuredDetailsEMI, INomineeDetails, IProposerDetailsEMI } from 'types'

interface IStateGroupEMI {
  suitabilityFormDetails: IProposerDetailsEMI
  insuredDetails: IInsuredDetailsEMI
  quotationDetails: {
    [key: string]: any
  }
  nomineeDetails: INomineeDetails
}
const initialState: IStateGroupEMI = {
  suitabilityFormDetails: {
    occupation: '',
    address1: '',
    address2: '',
    pincode: null,
    city: '',
    state: '',
    phone: '',
    email: '',
    emiTerm: null,
    emiAmountPerMonth: null,
    numberOfEmi: null,
  },
  insuredDetails: {
    first_name: '',
    last_name: '',
    dob: '',
    gender: '',
    relationship: '',
    occupation: '',
    unique_id: null,
  },
  quotationDetails: {},
  nomineeDetails: {
    nomineeSalutation: '',
    nomineeFirstName: '',
    nomineeLastName: '',
    dob: '',
    nomineeGender: '',
    relationship: '',
    nomineeEmail: '',
    nomineePhoneNumber: '',
  },
}

const groupEMISlice = createSlice({
  name: 'groupEMISlice',
  initialState: initialState,
  reducers: {
    updateInsuredDetails: (state, action) => {
      state.insuredDetails = action.payload
    },
    updateSuitabilityFormDetails: (state, action) => {
      state.suitabilityFormDetails = action.payload
    },
    updateQuotationDetails: (state, action) => {
      state.quotationDetails = action.payload
    },
    updateNomineeDetails: (state, action) => {
      state.nomineeDetails = action.payload
    },

    resetGroupLifeData: () => initialState,
  },
})

const { reducer } = groupEMISlice

const {
  updateInsuredDetails,
  updateSuitabilityFormDetails,
  updateQuotationDetails,
  updateNomineeDetails,
} = groupEMISlice.actions

export {
  reducer as groupEMIReducer,
  updateInsuredDetails,
  updateQuotationDetails,
  updateNomineeDetails,
  updateSuitabilityFormDetails,
}
